import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import includes from 'lodash/includes';
import {push as changeURL} from 'react-router-redux';
import isEmpty from 'lodash/isEmpty';

import mapDispatch from '~/misc/mapDispatch';
import SiderBarController from './share/SiderBar';
import store from '~/store';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import Spinner from '~/components/common/Spinner';
import {getAdminAccountInfo} from '~/modules/adminAccountPage/actions';
import {track} from '~/misc/metrics';

import css from './index.css';
import sharedCSS from '~/components/shared.css';
import accountPageCss from './share.css';

const routeConfig = {
  route: {
    'account-profile': 0,
    'dot-verify': 1,
    'membership-manage': 2,
    'payment-history': 3,
    'payment-setting': 4,
  },
  path: 'my-account',
  index: 'account-profile'
}

class MyaccountPage extends React.Component {
  constructor(props) {
    super(props);
    this.getPageInfo = this.getPageInfo.bind(this);
  }

  componentWillMount() {
    track('my account', {'My account - homepage': 1});
    // 新增逻辑未登录去首页
    if (!this.props.user.token) {
      this.props.gotoRoot();
    }

    if (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan.toLowerCase() === 'free') {
      this.props.gotoRoot();
    }

    if (this.props.account.userInfo.data) {
      this.judgeRoute();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.user.id && (this.props.user.id !== nextProps.user.id)
      || (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan.toLowerCase() === 'free')
      || (nextProps.account.userInfo.data && nextProps.account.userInfo.data.memberPlan.toLowerCase() === 'free')
    ) {
      this.props.gotoRoot();
    }

    if (!this.props.account.userInfo.data && nextProps.account.userInfo.data) {
      this.judgeRoute(nextProps);
    }
  }

  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          {this.props.account.userInfo
            && this.props.account.userInfo.data
            && (this.props.account.userInfo.data.memberPlan !== 'Free')
            && (
              <SiderBarController className={cs(css.siderBar)} props={this.state} config={routeConfig}>
                <div
                  className={cs(css.linkList)}
                  fn={this.props.goToAccountProfile}
                  title='Account Information'
                  data-qa='Account-profile-link'
                />
                <div
                  className={css.linkList}
                  fn={this.props.goToDotVerify}
                  title='Carrier Verification'
                  data-qa='Dot-verify-link'
                />
                <div
                  className={css.linkList}
                  fn={this.props.goToMembershipManage}
                  title='Membership Information'
                  data-qa='Membership-Manage-link'
                />
                <div
                  className={css.linkList}
                  fn={this.props.goToPaymentHistory}
                  title='Payment History'
                  data-qa='Payment-History-link'
                />
                <div
                  className={css.linkList}
                  fn={this.props.goToPaymentSetting}
                  title='Payment Setting'
                  data-qa='Payment-profile-link'
                />
              </SiderBarController>
            )
          }
          <div className={cs(css.content)}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    // const isLoggedIn = this.props.user.isLoggedIn;
    const accountInfo = this.props.adminAccountPage.accountInfo;
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => React.cloneElement(
        child,
        {
          user: this.props.user,
          account: this.props.account,
          adminAccountPage: this.props.adminAccountPage,
        }
      )
    );

    if (accountInfo.error) {
      return (
        <div className={accountPageCss.viewH} onClick={this.getPageInfo}>
          {accountInfo.error}
        </div>
      );
    }
    if (!isEmpty(accountInfo.data) && (accountInfo.data.memberPlan !== 'Free')) {
      return (
        <div>{childrenWithProps}</div>
      );
    }

    return (
      <div className={accountPageCss.viewH}>
        <div className={cs(accountPageCss.spinnerLine)}>
          <div className={accountPageCss.spinner}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  judgeRoute(param) {
    let propsData = param ? param : this.props;
    if (
      !isEmpty(propsData.account.userInfo.data)
      && Boolean(propsData.account.userInfo.data.userRole)
      && includes(propsData.account.userInfo.data.userRole.toLowerCase(), 'user')
    ) {
      this.props.goToUserAccount();
    } else if(
      !isEmpty(propsData.account.userInfo.data) &&
      Boolean(propsData.account.userInfo.data.userRole) &&
      includes(propsData.account.userInfo.data.userRole.toLowerCase(), 'admin')
    ) {
      this.getPageInfo();
    } else {
      this.props.gotoRoot();
    }
  }

  getPageInfo() {
    return store.dispatch((dispatch, getState) => getAdminAccountInfo(dispatch, getState));
  }
}

export default connect(({user, routing, account, adminAccountPage}) => ({
  user,
  routing,
  account,
  adminAccountPage,
}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  goToAccountProfile: () => changeURL('/my-account/account-profile'),
  goToMembershipManage: () => changeURL('/my-account/membership-manage'),
  goToPaymentHistory: () => changeURL('/my-account/payment-history'),
  goToPaymentSetting: () => changeURL('/my-account/payment-setting'),
  goToDotVerify: () => changeURL('/my-account/dot-verify'),
  goToUserAccount: () => changeURL('/user-account'),
  gotoRoot: () => changeURL('/'),
}))(MyaccountPage);



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/index.js